import React, { useRef, useState } from "react";
import { Grid, TextField } from "@material-ui/core";
import StyledButton from "../../../../../UIcomponent/Button";
import ProfileReq from "../../../../../Utility/Requester/ProfileReq";
import { Notify } from "../../../../../UIcomponent/NotificationManager";

const Sheba = (props) => {
  const { ShebaNumber } = props;
  const [isFetching, setIsFetching] = useState(false);
  const inputRef = useRef();
  console.log(ShebaNumber);
  function onSave() {
    const sheba = inputRef.current.value;
    const data = { ShebaNumber: sheba };

    if (sheba.length !== 26 || sheba.substring(0, 2) !== "IR") {
      return Notify(
        "error",
        "شماره شبا اشتباه میباشد، لطفا شماره را به درستی وارد کنید",
        3000
      );
    }
    setIsFetching(true);
    ProfileReq.UpdateSheba(data)
      .then((res) => {
        Notify("success", "اطلاعات شماره شبا موفقیت ذخیره شد.", 3000);
        setIsFetching(false);
      })
      .catch(() => {
        Notify("error", "خطا در ذخیره سازی اطلاعات، دوباره تلاش کنید.", 3000);
        setIsFetching(false);
      });
  }

  return (
    <>
      <div className="title-bar">
        <h3>اطلاعات بانکی</h3>
      </div>
      <br />
      <Grid xs="12" md="6">
        <TextField
          style={{ width: "100%" }}
          defaultValue={ShebaNumber || ""}
          inputRef={inputRef}
          id="outlined-basic"
          label="شماره شبا"
          variant="outlined"
        />
      </Grid>
      <StyledButton loading={isFetching} onClick={onSave} primary>
        ذخیره
      </StyledButton>
    </>
  );
};

export default Sheba;
